// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"9":"Contact","594":"about","828":"Team","940":"Service"}[chunkId] + "." + {"9":"aa1e5b4f","594":"0de7a456","828":"0a43475b","940":"b3b655b9"}[chunkId] + ".css";
};